export const GET_DATA_DASHBOARD = '@DASHBOARD_MAIN/GET_DATA_DASHBOARD'
export const GET_DATA_TAB_CHART = '@DASHBOARD_MAIN/GET_DATA_TAB_CHART'
export const GET_DATA_TOP_SEARCH = '@DASHBOARD_MAIN/GET_DATA_TOP_SEARCH'
